/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
import React, { useState } from "react";
import { NavLink, withRouter } from "react-router-dom";
import {
  Layout,
  Typography,
  Menu,
  Icon,
  message,
  Badge,
} from "antd";
import "./navigation.less";
import GlobalHeaderRight from "./GlobalHeader/RightContent";
import { useEffect } from "react";
import { platformApi } from "../../api";
import { ContextAPI } from "../../ContextAPI";
import { useContext } from "react";
import LOGO1 from "../../assets/logo-04.png";
import LOGOSmall from "../../assets/Smallicon.png";

import { useBranch } from "../../ContextAPI/branch";
import DashboardIcon from '@material-ui/icons/Dashboard';
import BuildIcon from '@material-ui/icons/Build';
import CachedIcon from '@material-ui/icons/Cached';
import PersonIcon from '@material-ui/icons/Person';
import PhoneCallIcon from '@material-ui/icons/Phone';
import PhoneCallbackIcon from '@material-ui/icons/PhoneCallback';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import DescriptionIcon from '@material-ui/icons/Description';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SettingsIcon from '@material-ui/icons/Settings';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import StorageIcon from '@material-ui/icons/Storage';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PaymentIcon from '@material-ui/icons/Payment';
import TwoWheelerIcon from '@material-ui/icons/TwoWheeler';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ShopIcon from '@material-ui/icons/Shop';
import FileCopyIcon from '@material-ui/icons/FileCopy';

// import Dashboard from "../Dashboard";

const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;

const Navigation = (props) => {
  const { loginCredintials, setLoginCredintials } = useContext(ContextAPI);
  const { type, category } = props.match.params;
  const { content: ContentComponent } = props;

  const [openedSubMenu, setOpenedSubMenu] = useState("company_masters");
  const [collapsed, setCollapsed] = useState(false);
  const [collapseMargin, setCollapseMargin] = useState(240);
  const [isMobile, setIsMobile] = useState(false);
  const [branchName, setBranchName] = useState([{ name: "Select Branch" }]);
  const [currentBranch, setCurrentBranch] = useState([]);
  const { selectBranch, setSelectBranch } = useBranch();
  const [branches, setBranches] = useState(() => {
    // Load from localStorage if available
    const saved = localStorage.getItem("branches");
    return saved ? JSON.parse(saved) : [];
  });
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [theme] = useState("light");
  const [pendingTransfersCount, setPendingTransfersCount] = useState(0);
  const [pendingNumberPlateTransfersCount, setPendingNumberPlateTransfersCount] = useState(0);
  const [sparesAdjustmentHighlight, setSparesAdjustmentHighlight] = useState(false);

  useEffect(() => {
    let highlightTimer = null;
    const triggerHighlight = () => {
      setSparesAdjustmentHighlight(true);
      if (highlightTimer) clearTimeout(highlightTimer);
      highlightTimer = setTimeout(() => {
        setSparesAdjustmentHighlight(false);
      }, 3000);
    };

    // Check if highlight was triggered recently (e.g. within 3 seconds)
    const storedTime = sessionStorage.getItem("sparesAdjustmentHighlightTime");
    if (storedTime && Date.now() - parseInt(storedTime, 10) < 3000) {
      const remainingTime = 3000 - (Date.now() - parseInt(storedTime, 10));
      setSparesAdjustmentHighlight(true);
      highlightTimer = setTimeout(() => {
        setSparesAdjustmentHighlight(false);
        sessionStorage.removeItem("sparesAdjustmentHighlightTime");
      }, remainingTime);
    }

    const handleStockAdjustment = () => {
      triggerHighlight();
    };

    window.addEventListener("stockAdjustmentCreated", handleStockAdjustment);
    return () => {
      window.removeEventListener("stockAdjustmentCreated", handleStockAdjustment);
      if (highlightTimer) clearTimeout(highlightTimer);
    };
  }, []);

  const fetchPendingTransfers = () => {
    platformApi
      .get("/api/sparesInventory/pendingTransfers")
      .then((res) => {
        if (res?.data?.response?.code === 200) {
          setPendingTransfersCount(res.data.response.data.count || 0);
        }
      })
      .catch((err) => console.error("Error fetching pending transfers:", err));
  };

  const fetchPendingNumberPlateTransfers = () => {
    platformApi
      .get("/api/inventoryTransfers/pendingNumberPlateTransfers")
      .then((res) => {
        if (res?.data?.code === 200) {
          setPendingNumberPlateTransfersCount(res.data.count || 0);
        }
      })
      .catch((err) => console.error("Error fetching pending number plate transfers:", err));
  };

  useEffect(() => {
    fetchPendingTransfers();
    const handlePendingUpdate = () => fetchPendingTransfers();
    window.addEventListener("pendingTransfersUpdated", handlePendingUpdate);
    const interval = setInterval(fetchPendingTransfers, 60000);
    return () => {
      window.removeEventListener("pendingTransfersUpdated", handlePendingUpdate);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    fetchPendingNumberPlateTransfers();
    const handlePendingUpdate = () => fetchPendingNumberPlateTransfers();
    window.addEventListener("pendingNumberPlateTransfersUpdated", handlePendingUpdate);
    const interval = setInterval(fetchPendingNumberPlateTransfers, 60000);
    return () => {
      window.removeEventListener("pendingNumberPlateTransfersUpdated", handlePendingUpdate);
      clearInterval(interval);
    };
  }, []);

  const handleToggle = () => {
    setCollapsed(!collapsed);
    setCollapseMargin(collapsed ? 240 : 80);
  };
  const { SubMenu, Item } = Menu;

  // const logoText =
  useEffect(() => {
    // Save to localStorage whenever branches change
    localStorage.setItem("branches", JSON.stringify(branches));
  }, [branches]);

  useEffect(() => {
    if (Array.isArray(selectBranch)) {
      if (selectBranch.length > 0) {
        setBranchName(selectBranch);
        setSelectedBranch(selectBranch.map((b) => b.name));
      } else {
        setBranchName([{ name: "Select Branch" }]);
        setSelectedBranch([]);
      }
    } else if (loginCredintials.branch && loginCredintials.branch.length > 0) {
      setBranchName(loginCredintials.branch);
      setSelectedBranch(loginCredintials.branch.map((b) => b.name));
    } else {
      setBranchName([{ name: "Select Branch" }]);
      setSelectedBranch([]);
    }
  }, [selectBranch, loginCredintials]);

  // Detect mobile viewport and auto-collapse sidebar
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992; // antd lg breakpoint
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setCurrentBranch(loginCredintials && loginCredintials.branch);
  }, [loginCredintials]);

  useEffect(() => {
    if (!type) return;
    const generalKeys = ["customer_details", "vehicles", "call_logs", "notifications", "whatsapp", "purchase_return", "final_inspection", "customer_parts_order", "counter_sale"];
    const salesKeys = ["quotations", "follow-ups", "booking_register", "sales_register", "vehicle_sale_invoice", "sales_feedback_call", "numberPlating"];
    const serviceKeys = ["job_order", "gate_pass_verification", "estimate", "material_issue", "labour_perform", "job_invoice", "servicefeedbackcall"];
    const sparesKeys = ["customerspare", "counter_sale"];
    const purchaseKeys = ["vehicle_purchase_invoice", "purchase_spares_invoice"];
    const reminderKeys = ["service-followups", "insuranceRenewal", "otherinsuranceRenewal"];
    const promotionKeys = ["groups", "tasks", "promotion"];
    const reportKeys = ["report", "spares", "vehicle", "denomination_inventory", "stockcheck", "spares_adjustment", "transferVehicles", "transferSpares", "transfer_number_plate", "servicereport"];
    const accountKeys = ["ledger", "ledger_details", "cash_withdrawal", "payment_acc", "receipt_acc"];

    if (generalKeys.includes(type)) setOpenedSubMenu("transaction_masters");
    else if (salesKeys.includes(type)) setOpenedSubMenu("sales_submenu");
    else if (serviceKeys.includes(type)) setOpenedSubMenu("service_submenu");
    else if (sparesKeys.includes(type)) setOpenedSubMenu("spares_submenu");
    else if (purchaseKeys.includes(type)) setOpenedSubMenu("purchase_submenu");
    else if (reminderKeys.includes(type)) setOpenedSubMenu("reminder_submenu");
    else if (promotionKeys.includes(type)) setOpenedSubMenu("promotions");
    else if (reportKeys.includes(type)) setOpenedSubMenu("reports");
    else if (accountKeys.includes(type)) setOpenedSubMenu("accounts_submenu");
  }, [type]);

  const changeSubMenu = (prop) => {
    if (openedSubMenu !== prop.key) setOpenedSubMenu(prop.key);
    else setOpenedSubMenu();
  };
  function checkDropdownList(type) {
    let bool = false;

    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        const subNorm = (each.subModule || "").toLowerCase().replace(/[-_]/g, "");
        const targetNorm = (type || "").toLowerCase().replace(/[-_]/g, "");
        const isStockCheckMatch =
          ["stockcheck", "stockcity", "stockinward", "stockchecking"].includes(targetNorm) &&
          ["stockcheck", "stockcity", "stockinward", "stockchecking"].includes(subNorm);

        if (
          (each.subModule === type && each.access && each.access.read === true) ||
          ((each.subModule === type || subNorm === targetNorm || isStockCheckMatch) && each.access && each.access.read === true) ||
          (type === "service-followups" &&
            each.subModule === "service_reminder" &&
            each.access &&
            each.access.create === true)
        ) {
          bool = true;
        }
      });
    return bool;
  }

  function checkDashboard() {
    return Boolean(
      loginCredintials.departmentType?.some((type) => type === "Sales")
    );
  }

  function checkGeneral() {
    return (
      !checkDropdownList("customer_details") &&
      !checkDropdownList("vehicles") &&
      !checkDropdownList("call_logs") &&
      !checkDropdownList("notifications") &&
      !checkDropdownList("whatsapp_web") &&
      !checkDropdownList("purchase_return") &&
      !checkDropdownList("final_inspection") &&
      !checkDropdownList("customer_parts_order") &&
      !checkDropdownList("customer_sales_spares")
    );
  }

  function checkSales() {
    return (
      !checkDropdownList("quotations") &&
      !checkDropdownList("follow-ups") &&
      !checkDropdownList("booking_register") &&
      !checkDropdownList("SALESREGISTER") &&
      !checkDropdownList("VEHICLESALEINVOICE") &&
      !checkDropdownList("SALESFEEDBACKCALL") &&
      !checkDropdownList("number_plate_ordering")
    );
  }

  function checkServiceSub() {
    return (
      !checkDropdownList("job_order") &&
      !checkDropdownList("gate_pass_verification") &&
      !checkDropdownList("estimate") &&
      !checkDropdownList("material_issue") &&
      !checkDropdownList("labour_perform") &&
      !checkDropdownList("job_invoice") &&
      !checkDropdownList("SERVICEFEEDBACKCALL")
    );
  }

  function checkSparesSub() {
    return (
      !checkDropdownList("customer_spare_order") &&
      !checkDropdownList("counter_sale")
    );
  }

  function checkPurchaseSub() {
    return (
      !checkDropdownList("vehicle_purchase_invoice") &&
      !checkDropdownList("purchase_spares_invoice")
    );
  }

  function checkReminderSub() {
    return (
      !checkDropdownList("service-followups") &&
      !checkDropdownList("insurance_renewal_reminder")
    );
  }

  function checkPromotion() {
    return !checkDropdownList("groups") && !checkDropdownList("tasks");
  }

  function checkReports() {
    return (
      !checkDropdownList("spares_inventory") &&
      !checkDropdownList("stock_check") &&
      !checkDropdownList("vehicle_inventory") &&
      !checkDropdownList("denomination_inventory") &&
      !checkDropdownList("Spares_Adjustment") &&
      !checkDropdownList("transfer_vehicles") &&
      !checkDropdownList("transfer_spares") &&
      !checkDropdownList("transfer_Number_Plates") &&
      !checkDropdownList("Service Report")
    );
  }

  function checkServiceDashboard() {
    let bool = false;
    loginCredintials.departmentType &&
      loginCredintials.departmentType.map((type) => {
        if (type === "General") {
          bool = false;
        } else if (type === "Service") {
          bool = true;
        }
      });
    if (
      loginCredintials.departmentType &&
      loginCredintials.departmentType.length === 0
    ) {
      bool = false;
    }
    return bool;
  }

  function checkAccounts() {
    return (
      !checkDropdownList("ledger") &&
      !checkDropdownList("ledger_details") &&
      !checkDropdownList("Cash_Withdrawal") &&
      !checkDropdownList("Payment") &&
      !checkDropdownList("Receipt")
    );
  }

  const applyBranchSelection = (updatedSelected) => {
    if (!updatedSelected || updatedSelected.length === 0) {
      message.error("Select atleast one branch");
      return;
    }

    const selectedNames = updatedSelected.map((b) => b.name);
    const unselectedBranches = (branches || []).filter(
      (b) => !updatedSelected.some((sel) => String(sel.id) === String(b.id))
    );
    const mergedBranches = [...updatedSelected, ...unselectedBranches];

    setBranchName(updatedSelected);
    setSelectedBranch(selectedNames);
    setSelectBranch(updatedSelected);
    setBranches(mergedBranches);

    const branch = updatedSelected.map((each) => each.id);
    platformApi.post("/api/user/token", { branch }).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          localStorage.setItem("token", response.data);
          props.history.push("/autoadmin");
        }
      }
    });
  };

  const handleBranchPillClick = (branch) => {
    if (!branch || !branch.id) return;

    const selectedSource =
      Array.isArray(selectBranch) && selectBranch.length
        ? selectBranch
        : Array.isArray(branchName)
          ? branchName.filter((b) => b && b.name !== "Select Branch")
          : [];

    const alreadySelected = selectedSource.some(
      (b) => String(b.id) === String(branch.id)
    );

    let updatedSelected;
    if (alreadySelected) {
      updatedSelected = selectedSource.filter(
        (b) => String(b.id) !== String(branch.id)
      );
    } else {
      const existing = (branches || []).find(
        (b) => String(b.id) === String(branch.id)
      );
      updatedSelected = [
        ...selectedSource,
        {
          id: branch.id,
          name: branch.name,
          lat: existing ? existing.lat : branch.lat || 0,
          lon: existing ? existing.lon : branch.lon || 0,
        },
      ];
    }

    applyBranchSelection(updatedSelected);
  };
  
  return (
    <Layout
      hasSider
      style={{
        height: "100vh",
      }}
    >
      <Sider
        className="sider"
        trigger={null}
        collapsible
        collapsed={collapsed}
        width="240px"
        collapsedWidth={isMobile ? 0 : 80}
        height="100vh"
        style={{
          overflowY: "scroll",
          height: "100%",
          left: 0,
          boxShadow: "3px 0 17px 0 rgba(0, 0, 0, 0.15)",
          zIndex: 101,
          fontFamily: "Arial",
        }}
        breakpoint="lg"
        onBreakpoint={(broken) => {
          setIsMobile(broken);
          if (broken) setCollapsed(true);
        }}
        theme={theme}
      >
        <Title level={2} style={{ margin: "1rem 1.2rem" }}>
          {!collapsed ? (
            <img style={{ width: "100%" }} src={LOGO1}></img>
          ) : (
            <img style={{ width: "100%" }} src={LOGOSmall}></img>
          )}
        </Title>

        <Menu
          openKeys={openedSubMenu ? [openedSubMenu] : []}
          selectedKeys={[
            type === "promotion" 
              ? category 
              : type === "report" 
                ? (category === "spares" ? "spares" : category === "vehicle" ? "vehicle" : category === "denomination" ? "denomination_inventory" : category)
                : type === "spares_adjustment"
                  ? "Spares_Adjustment"
                  : type
          ]}
          theme={theme}
          mode="inline"
          inlineCollapsed={collapsed}
          // onMenuCloseDelay={5}
          defaultOpenKeys={["transaction_masters"]}
        >
          {checkDashboard() ? (
            <Menu.Item key="dashboard">
              <NavLink to="/autoadmin/dashboard">
                <DashboardIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                <span
                  style={{
                    fontSize: "14px",
                    color: "rgb(108, 123, 138)",
                  }}
                >
                  Sales Dashboard
                </span>
              </NavLink>
            </Menu.Item>
          ) : (
            <span></span>
          )}

          {checkServiceDashboard() ? (
            <Menu.Item key="services">
              <NavLink to="/autoadmin/services">
                <BuildIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                <span
                  style={{
                    fontSize: "14px",
                    color: "rgb(108, 123, 138)",
                  }}
                >
                  Service Dashboard
                </span>
              </NavLink>
            </Menu.Item>
          ) : (
            <span></span>
          )}

          {!checkGeneral() ? (
            <SubMenu
              onTitleClick={changeSubMenu}
              key="transaction_masters"
              title={
                <span>
                  <CachedIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "15.5px" }}>General</span>
                </span>
              }
            >
            {checkDropdownList("customer_details") ? (
              <Menu.Item key="customer_details">
                <NavLink to="/autoadmin/customer_details">
                  <PersonIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span
                    style={{
                      fontSize: "14px",
                      color: "rgb(108, 123, 138)",
                    }}
                  >
                    Customer Details
                  </span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

            {checkDropdownList("vehicles") ? (
              <Menu.Item key="vehicles">
                <NavLink to="/autoadmin/vehicles">
                  <TwoWheelerIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span
                    style={{
                      fontSize: "14px",
                      marginLeft: "3px",
                      color: "rgb(108, 123, 138)",
                    }}
                  >
                    Vehicles
                  </span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

            {checkDropdownList("call_logs") ? (
              <Menu.Item key="call_logs">
                <NavLink to="/autoadmin/call_logs">
                  <PhoneCallbackIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span
                    style={{
                      fontSize: "14px",
                      marginLeft: "3px",
                      color: "rgb(108, 123, 138)",
                    }}
                  >
                    Call Logs
                  </span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

            {checkDropdownList("notifications") ? (
              <Menu.Item key="notifications">
                <NavLink to="/autoadmin/notifications">
                  <NotificationsIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span
                    style={{
                      fontSize: "14px",
                      marginLeft: "3px",
                      color: "rgb(108, 123, 138)",
                    }}
                  >
                    Notifications
                  </span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

            {checkDropdownList("whatsapp_web") ? (
              <Menu.Item key="whatsapp">
                <NavLink to="/autoadmin/whatsapp">
                  <DescriptionIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Whatsapp Web</span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

            {checkDropdownList("purchase_return") ? (
              <Menu.Item key="purchase_return">
                <NavLink to="/autoadmin/purchase_return">
                  <DescriptionIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Purchase Return</span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

            {checkDropdownList("final_inspection") ? (
              <Menu.Item key="final_inspection">
                <NavLink to="/autoadmin/final_inspection">
                  <AssignmentTurnedInIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Final Inspection</span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

            {checkDropdownList("customer_parts_order") ? (
              <Menu.Item key="customer_parts_order">
                <NavLink to="/autoadmin/customer_parts_order">
                  <AssignmentIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Customer Parts Order</span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

            {checkDropdownList("customer_sales_spares") ? (
              <Menu.Item key="customer_sales_spares">
                <NavLink to="/autoadmin/counter_sale">
                  <ShoppingBasketIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Sale Spares</span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}
          </SubMenu>
          ) : null}

            {!checkSales() ? (
              <SubMenu
                onTitleClick={changeSubMenu}
                key="sales_submenu"
                title={
                  <span>
                    <TrendingUpIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "15.5px" }}>Sales</span>
                  </span>
                }
              >
              {checkDropdownList("quotations") ? (
                <Menu.Item key="quotations">
                  <NavLink to="/autoadmin/quotations">
                    <DescriptionIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Quotations</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("follow-ups") ? (
                <Menu.Item key="follow-ups">
                  <NavLink to="/autoadmin/follow-ups">
                    <ScheduleIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Follow Ups</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("booking_register") ? (
                <Menu.Item key="booking_register">
                  <NavLink to="/autoadmin/booking_register">
                    <EventAvailableIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Booking Register</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("SALESREGISTER") ? (
                <Menu.Item key="sales_register">
                  <NavLink to="/autoadmin/sales_register">
                    <AssignmentTurnedInIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Sales Register</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("VEHICLESALEINVOICE") ? (
                <Menu.Item key="vehicle_sale_invoice">
                  <NavLink to="/autoadmin/vehicle_sale_invoice">
                    <AssignmentTurnedInIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Vehicle Sale Invoice</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("SALESFEEDBACKCALL") ? (
                <Menu.Item key="sales_feedback_call">
                  <NavLink to="/autoadmin/sales_feedback_call">
                    <PhoneCallIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Sales Feedback Call</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
              
              {checkDropdownList("number_plate_ordering") ? (
                <Menu.Item key="numberPlating">
                  <NavLink to="/autoadmin/number_plating">
                    <DirectionsBikeIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Number Plate Ordering</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
            </SubMenu>
            ) : null}

            {!checkServiceSub() ? (
              <SubMenu
                onTitleClick={changeSubMenu}
                key="service_submenu"
                title={
                  <span>
                    <BuildIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "15.5px" }}>Service</span>
                  </span>
                }
              >
              {checkDropdownList("job_order") ? (
                <Menu.Item key="job_order">
                  <NavLink to="/autoadmin/job_order">
                    <BuildIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Job Card</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("gate_pass_verification") ? (
                <Menu.Item key="gate_pass_verification">
                  <NavLink to="/autoadmin/gate_pass_verification">
                    <BuildIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Gate Pass Verification</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("estimate") ? (
                <Menu.Item key="estimate">
                  <NavLink to="/autoadmin/estimate">
                    <DescriptionIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Estimate</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("material_issue") ? (
                <Menu.Item key="material_issue">
                  <NavLink to="/autoadmin/material_issue">
                    <BuildIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Parts Issue</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("labour_perform") ? (
                <Menu.Item key="labour_perform">
                  <NavLink to="/autoadmin/labour_perform">
                    <BuildIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Labour Perform</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("job_invoice") ? (
                <Menu.Item key="job_invoice">
                  <NavLink to="/autoadmin/job_invoice">
                    <FileCopyIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Job Invoice</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("SERVICEFEEDBACKCALL") ? (
                <Menu.Item key="servicefeedbackcall">
                  <NavLink to="/autoadmin/service_feedback_call">
                    <PhoneCallIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Service Feedback Call</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
              </SubMenu>
            ) : null}
            {!checkSparesSub() ? (
              <SubMenu
                onTitleClick={changeSubMenu}
                key="spares_submenu"
                title={
                  <span>
                    <SettingsIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "15.5px" }}>Spares</span>
                  </span>
                }
              >
              {checkDropdownList("customer_spare_order") ? (
                <Menu.Item key="customerspare">
                  <NavLink to="/autoadmin/customerspare">
                    <AssignmentIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Customer Spare Order</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("counter_sale") ? (
                <Menu.Item key="counter_sale">
                  <NavLink to="/autoadmin/counter_sale">
                    <ShoppingBasketIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Counter Sales</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
              </SubMenu>
            ) : null}

            {!checkPurchaseSub() ? (
              <SubMenu
                onTitleClick={changeSubMenu}
                key="purchase_submenu"
                title={
                  <span>
                    <ShoppingBasketIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "15.5px" }}>Purchase</span>
                  </span>
                }
              >
              {checkDropdownList("vehicle_purchase_invoice") ? (
                <Menu.Item key="vehicle_purchase_invoice">
                  <NavLink to="/autoadmin/vehicle_purchase_invoice">
                    <ShoppingCartIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Vehicle Purchase Invoice</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
              
              {checkDropdownList("purchase_spares_invoice") ? (
                <Menu.Item key="purchase_spares_invoice">
                  <NavLink to="/autoadmin/purchase_spares_invoice">
                    <ShopIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Spare Purchase Invoice</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
            </SubMenu>
            ) : null}

            {!checkReminderSub() ? (
              <SubMenu
                onTitleClick={changeSubMenu}
                key="reminder_submenu"
                title={
                  <span>
                    <NotificationsIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "15.5px" }}>Reminder</span>
                  </span>
                }
              >
              {checkDropdownList("service-followups") ? (
                <Menu.Item key="service-followups">
                  <NavLink to="/autoadmin/service-followups">
                    <NotificationsIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Service Reminder</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("insurance_renewal_reminder") ? (
                <Menu.Item key="insuranceRenewal">
                  <NavLink to="/autoadmin/insurance_renewal_reminder">
                    <NotificationsIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Insurance Renewal</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("insurance_renewal_reminder") ? (
                <Menu.Item key="otherinsuranceRenewal">
                  <NavLink to="/autoadmin/other_insurance_renewal_reminder">
                    <NotificationsIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Other Insurance Renewal</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
            </SubMenu>
            ) : null}


          {!checkPromotion() ? (
            <SubMenu
              onTitleClick={changeSubMenu}
              key="promotions"
              title={
                <span>
                  <AnnouncementIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "15.5px" }}>Promotions</span>
                </span>
              }
            >
              {checkDropdownList("groups") ? (
                <Menu.Item key="groups">
                  <NavLink to="/autoadmin/promotion/groups">
                    <AnnouncementIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Groups</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
              {checkDropdownList("tasks") ? (
                <Menu.Item key="tasks">
                  <NavLink to="/autoadmin/promotion/tasks">
                    <AnnouncementIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Tasks</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
            </SubMenu>
          ) : (
            <span></span>
          )}

          {!checkReports() ? (
            <SubMenu
              onTitleClick={changeSubMenu}
              key="reports"
              title={
                <span style={(pendingTransfersCount + pendingNumberPlateTransfersCount) > 0 ? { color: "#cf1322", fontWeight: 600 } : {}}>
                  <StorageIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: (pendingTransfersCount + pendingNumberPlateTransfersCount) > 0 ? '#cf1322' : 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "15.5px" }}>Inventory Management</span>
                  {(pendingTransfersCount + pendingNumberPlateTransfersCount) > 0 && (
                    <Badge count={pendingTransfersCount + pendingNumberPlateTransfersCount} style={{ backgroundColor: "#ff4d4f", marginLeft: "8px", fontWeight: "bold" }} />
                  )}
                </span>
              }
            >
              {checkDropdownList("spares_inventory") ? (
                <Menu.Item key="spares">
                  <NavLink to="/autoadmin/report/spares">
                    <StorageIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Spares Inventory</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("stock_check") ? (
                <Menu.Item key="stockcheck">
                  <NavLink to="/autoadmin/stockcheck">
                    <StorageIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Stock Checking</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("vehicle_inventory") ? (
                <Menu.Item key="vehicle">
                  <NavLink to="/autoadmin/report/vehicle">
                    <TwoWheelerIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Vehicle Inventory</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
              {checkDropdownList("denomination_inventory") ? (
                <Menu.Item key="denomination_inventory">
                  <NavLink to="/autoadmin/report/denomination">
                    <AssignmentIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Denomination Inventory</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("Spares_Adjustment") ? (
                <Menu.Item
                  key="Spares_Adjustment"
                  style={sparesAdjustmentHighlight ? { backgroundColor: "#fff1f0", borderLeft: "4px solid #ff4d4f", transition: "all 0.3s ease" } : { transition: "all 0.3s ease" }}
                >
                  <NavLink to="/autoadmin/spares_adjustment">
                    <SettingsIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: sparesAdjustmentHighlight ? '#cf1322' : 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: sparesAdjustmentHighlight ? "#cf1322" : "rgb(108, 123, 138)", fontWeight: sparesAdjustmentHighlight ? 600 : "normal" }}>Spares Adjustment</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("transfer_vehicles") ? (
                <Menu.Item key="transferVehicles">
                  <NavLink to="/autoadmin/transfer/vehicles">
                    <DirectionsBikeIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Transfer Vehicles</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("transfer_spares") ? (
                <Menu.Item
                  key="transferSpares"
                  style={pendingTransfersCount > 0 ? { backgroundColor: "#fff1f0", borderLeft: "4px solid #ff4d4f" } : {}}
                >
                  <NavLink to="/autoadmin/transfer/spares">
                    <SettingsIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: pendingTransfersCount > 0 ? '#cf1322' : 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: pendingTransfersCount > 0 ? "#cf1322" : "rgb(108, 123, 138)", fontWeight: pendingTransfersCount > 0 ? 600 : "normal" }}>
                      Transfer Spares
                    </span>
                    {pendingTransfersCount > 0 && (
                      <Badge count={pendingTransfersCount} style={{ backgroundColor: "#ff4d4f", marginLeft: "8px" }} />
                    )}
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("transfer_Number_Plates") ? (
                <Menu.Item
                  key="transfer_number_plate"
                  style={pendingNumberPlateTransfersCount > 0 ? { backgroundColor: "#fff1f0", borderLeft: "4px solid #ff4d4f" } : {}}
                >
                  <NavLink to="/autoadmin/transfer/number_plates">
                    <SwapHorizIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: pendingNumberPlateTransfersCount > 0 ? '#cf1322' : 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: pendingNumberPlateTransfersCount > 0 ? "#cf1322" : "rgb(108, 123, 138)", fontWeight: pendingNumberPlateTransfersCount > 0 ? 600 : "normal" }}>
                      Transfer Number Plates
                    </span>
                    {pendingNumberPlateTransfersCount > 0 && (
                      <Badge count={pendingNumberPlateTransfersCount} style={{ backgroundColor: "#ff4d4f", marginLeft: "8px" }} />
                    )}
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("Service Report") ? (
                <Menu.Item key="servicereport">
                  <NavLink to="/autoadmin/report/ReportDashboard">
                    <DescriptionIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Service Report</span>
                  </NavLink>
                </Menu.Item>
              ) : null}
            </SubMenu>
          ) : (
            <span></span>
          )}

          {!checkAccounts() ? (
            <SubMenu
              onTitleClick={changeSubMenu}
              key="accounts_submenu"
              title={
                <span>
                  <AccountBalanceWalletIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "15.5px" }}>Accounts</span>
                </span>
              }
            >

              {checkDropdownList("ledger") ? (
              <Menu.Item key="ledger">
                <NavLink to="/autoadmin/ledger">
                  <DescriptionIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Ledger</span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

              {checkDropdownList("ledger_details") ? (
              <Menu.Item key="ledger_details">
                <NavLink to="/autoadmin/ledger_details">
                  <DescriptionIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                  <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Ledger Details</span>
                </NavLink>
              </Menu.Item>
            ) : (
              <span></span>
            )}

              {checkDropdownList("Cash_Withdrawal") ? (
                <Menu.Item key="cash_withdrawal">
                  <NavLink to="/autoadmin/Cash_Withdrawal">
                    <AccountBalanceWalletIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Cash Withdrawal</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("Payment") ? (
                <Menu.Item key="payment_acc">
                  <NavLink to="/autoadmin/payment">
                    <PaymentIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Payment</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}

              {checkDropdownList("Receipt") ? (
                <Menu.Item key="receipt_acc">
                  <NavLink to="/autoadmin/receipt">
                    <ReceiptIcon style={{ fontSize: '20px', marginRight: '10px', verticalAlign: 'middle', color: 'rgba(0,0,0,0.65)' }} />
                    <span style={{ fontSize: "14px", color: "rgb(108, 123, 138)" }}>Receipt</span>
                  </NavLink>
                </Menu.Item>
              ) : (
                <span></span>
              )}
            </SubMenu>
          ) : (
            <span></span>
          )}

        </Menu>
      </Sider>
      <Layout style={{ height: "100vh" }}>
        <Header
          style={{
            padding: 0,
            width: "100%",
            height: "64px",
            zIndex: 110,
            boxShadow: "0 3px 2px 0 rgba(0, 0, 0, 0.05)",
            position: "sticky",
            top: 0,
            background: "#fff",
          }}
        >
          <div className="global-header">
            <span className="global-header-trigger">
              <Icon
                type={collapsed ? "menu-unfold" : "menu-fold"}
                onClick={handleToggle}
              />
            </span>
            <div className="nav-branch-header">
              <div className="nav-selected-branches">
                {(() => {
                  const selectedSource =
                    Array.isArray(selectBranch) && selectBranch.length
                      ? selectBranch
                      : branchName;
                  const selectedIds = selectedSource
                    .filter((b) => b && b.name !== "Select Branch")
                    .map((b) => String(b.id));
                  const pillSource = currentBranch?.length
                    ? currentBranch
                    : branchName;
                  const hasPills = pillSource.some(
                    (e) => e && e.name !== "Select Branch"
                  );

                  if (!hasPills) {
                    return (
                      <span className="nav-branch-empty">
                        Select Branch Here
                      </span>
                    );
                  }

                  return pillSource.map((e) => {
                    if (!e || e.name === "Select Branch") return null;
                    const isSelected = selectedIds.includes(String(e.id));
                    return (
                      <span
                        key={e.id || e.name}
                        className={`nav-branch-pill${
                          isSelected ? " nav-branch-pill--selected" : ""
                        }`}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleBranchPillClick(e);
                        }}
                      >
                        <Icon type="environment" />
                        {e.name}
                      </span>
                    );
                  });
                })()}
              </div>
            </div>
            <GlobalHeaderRight theme="dark" layout="topmenu" />
          </div>
        </Header>
        <Content
          style={{
            // margin: "30px 16px",
            padding: 24,
            background: "#f4f7fb",
            minHeight: "max-content",
          }}
        >
          <ContentComponent />
        </Content>
      </Layout>
    </Layout>
  );
};

export default withRouter(Navigation);
